export const countries = [
  'السعودية',
  'مصر',
  'الإمارات العربية المتحدة',
  'الكويت',
  'البحرين',
  'قطر',
  'عُمان',
  'الأردن',
  'فلسطين',
  'لبنان',
  'سوريا',
  'العراق',
  'اليمن',
  'السودان',
  'ليبيا',
  'تونس',
  'الجزائر',
  'المغرب',
  'موريتانيا',
  'الصومال',
  'جيبوتي',
  'جزر القمر',
  'دولة أخرى'
];

const featuredCountryOptions = [
  {value:'',label:'اختر دولة'},
  {value:'SA',label:'السعودية',view:[23.9,45.1,5]},{value:'EG',label:'مصر',view:[26.8,30.8,5]},
  {value:'AE',label:'الإمارات العربية المتحدة',view:[24.3,54.4,7]},{value:'KW',label:'الكويت',view:[29.3,47.5,8]},
  {value:'BH',label:'البحرين',view:[26.0,50.5,9]},{value:'QA',label:'قطر',view:[25.3,51.2,8]},
  {value:'OM',label:'عُمان',view:[20.6,56.1,6]},{value:'JO',label:'الأردن',view:[31.2,36.5,7]},
  {value:'PS',label:'فلسطين',view:[31.9,35.2,8]},{value:'LB',label:'لبنان',view:[33.9,35.8,8]},
  {value:'SY',label:'سوريا',view:[35.0,38.5,7]},{value:'IQ',label:'العراق',view:[33.0,44.0,6]},
  {value:'YE',label:'اليمن',view:[15.6,47.6,6]},{value:'SD',label:'السودان',view:[15.5,30.2,5]},
  {value:'LY',label:'ليبيا',view:[27.0,17.0,5]},{value:'TN',label:'تونس',view:[34.0,9.0,7]},
  {value:'DZ',label:'الجزائر',view:[28.0,2.6,5]},{value:'MA',label:'المغرب',view:[31.8,-7.1,6]},
  {value:'MR',label:'موريتانيا',view:[20.3,-10.3,5]},{value:'SO',label:'الصومال',view:[5.2,46.2,5]},
  {value:'TR',label:'تركيا',view:[39.0,35.2,6]},{value:'ID',label:'إندونيسيا',view:[-2.5,118,4]},
  {value:'MY',label:'ماليزيا',view:[4.2,102,6]},{value:'PK',label:'باكستان',view:[30.4,69.3,5]},
  {value:'GB',label:'إنجلترا',view:[54.5,-2.5,6]},{value:'US',label:'الولايات المتحدة',view:[39.8,-98.6,4]}
];

const isoCountryCodes='AD AE AF AG AI AL AM AO AQ AR AS AT AU AW AX AZ BA BB BD BE BF BG BH BI BJ BL BM BN BO BQ BR BS BT BV BW BY BZ CA CC CD CF CG CH CI CK CL CM CN CO CR CU CV CW CX CY CZ DE DJ DK DM DO DZ EC EE EG EH ER ES ET FI FJ FK FM FO FR GA GB GD GE GF GG GH GI GL GM GN GP GQ GR GS GT GU GW GY HK HM HN HR HT HU ID IE IL IM IN IO IQ IR IS IT JE JM JO JP KE KG KH KI KM KN KP KR KW KY KZ LA LB LC LI LK LR LS LT LU LV LY MA MC MD ME MF MG MH MK ML MM MN MO MP MQ MR MS MT MU MV MW MX MY MZ NA NC NE NF NG NI NL NO NP NR NU NZ OM PA PE PF PG PH PK PL PM PN PR PS PT PW PY QA RE RO RS RU RW SA SB SC SD SE SG SH SI SJ SK SL SM SN SO SR SS ST SV SX SY SZ TC TD TF TG TH TJ TK TL TM TN TO TR TT TV TW TZ UA UG UM US UY UZ VA VC VE VG VI VN VU WF WS YE YT ZA ZM ZW'.split(' ');
const countryNames=new Intl.DisplayNames(['ar'],{type:'region'});
const featuredCodes=new Set(featuredCountryOptions.map(item=>item.value));
export const countryOptions=[
  ...featuredCountryOptions,
  ...isoCountryCodes.filter(code=>!featuredCodes.has(code)).map(code=>({value:code,label:countryNames.of(code)||code}))
].sort((a,b)=>!a.value?-1:!b.value?1:a.label.localeCompare(b.label,'ar'));
